import type { JSX } from 'react';
import { Label } from 'ts/components/Label';
import { useFilteredTestExecutionResultList } from 'ts/commons/components/PartitionContext';
import { TestExecutionResultLabel } from 'ts/commons/components/TestExecutionResultLabel';
import type { PartitionAndTestExecutionResult } from 'typedefs/PartitionAndTestExecutionResult';

/** Props for TestExecutionResultsTable. */
type TestExecutionResultsTableProps = {
	testExecutionResults?: PartitionAndTestExecutionResult[];
	emptyMessage: string;
};

/** Shows a small table with the test execution results for a single test and multiple partitions. */
export function TestExecutionResultsTable({
	testExecutionResults,
	emptyMessage
}: TestExecutionResultsTableProps): JSX.Element | null {
	const filteredResults = useFilteredTestExecutionResultList(testExecutionResults ?? []);
	if (filteredResults.length === 0) {
		return <p>{emptyMessage}</p>;
	}

	return (
		<table className="borderless mt-1">
			<tbody>
				{filteredResults.map(entry => (
					<tr className="[&>td]:py-1 [&>td]:pr-2" key={entry.partition}>
						<td>
							<Label>{entry.partition}</Label>
						</td>
						<td>
							<TestExecutionResultLabel result={entry.result} />
						</td>
					</tr>
				))}
			</tbody>
		</table>
	);
}
